import { useState } from "react";
import { Link } from "react-router-dom";
import { QuoteModal } from "@/components/QuoteModal";

export const HomeCTA = () => {
  const [quoteOpen, setQuoteOpen] = useState(false);

  return (
    <section data-testid="home-cta" className="bg-[#0B4F37]">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16 sm:py-20 text-center">
        <h2
          data-testid="home-cta-title"
          className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white"
        >
          Looking for Quality Agricultural Products from India?
        </h2>
        <p data-testid="home-cta-subtitle" className="mt-4 text-base sm:text-lg text-white/80">
          Share your requirement with RKG NATURALS.
        </p>
        <div className="mt-9 flex flex-wrap items-center justify-center gap-4">
          <button
            type="button"
            data-testid="home-cta-quote-button"
            onClick={() => setQuoteOpen(true)}
            className="inline-flex items-center gap-2 rounded-full bg-white text-[#042D1F] font-semibold px-7 py-3.5 hover:bg-emerald-50 transition-colors"
          >
            Request a Quote
          </button>
          <Link
            to="/contact-us"
            data-testid="home-cta-contact-link"
            className="inline-flex items-center gap-2 rounded-full border border-white/40 text-white font-semibold px-7 py-3.5 hover:bg-white/10 transition-colors"
          >
            Contact Us
          </Link>
        </div>
      </div>

      <QuoteModal open={quoteOpen} onOpenChange={setQuoteOpen} />
    </section>
  );
};
